import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { applyZoom } from "@/lib/display";

const SIZES = [
  ["compact", "Compacte", "Plus de lignes à l'écran, comme ScreenConnect", "text-[12px]"],
  ["normal", "Normale", "Taille par défaut", "text-[14px]"],
  ["large", "Grande", "Plus lisible sur grand écran", "text-[16px]"],
];
const LAYOUTS = [
  ["sv1", "ScreenView 1", "Disposition classique : rail d'icônes, colonne des groupes, liste et fiche du poste.",
    <div key="a" className="flex h-full gap-0.5"><div className="w-2 bg-slate-300" /><div className="w-6 bg-slate-200" /><div className="flex-1 bg-white" /><div className="w-8 bg-slate-100" /></div>],
  ["sv2", "ScreenView 2", "Menu bleu nuit repliable (Espaces, Vues, Clients), liste compacte et fiche avec aperçu d'écran et onglets RMM.",
    <div key="b" className="flex h-full gap-0.5"><div className="w-7 bg-[#0b1e3f]" /><div className="w-8 bg-white" /><div className="flex-1 bg-slate-100 p-0.5"><div className="h-full rounded-sm bg-white" /></div></div>],
];

const Choice = ({ on, onClick, id, children }) => (
  <button onClick={onClick} data-testid={id}
    className={`text-left rounded-lg border p-4 transition-colors ${on ? "border-blue-600 bg-blue-50 ring-1 ring-blue-600" : "border-slate-200 hover:border-slate-400"}`}>{children}</button>
);

export const DisplaySettings = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/settings/display").then(({ data }) => setD(data)).catch(() => setD({ text_size: "normal", layout: "sv1" })); }, []);
  const save = (body, msg) => api.put("/settings/display", body)
    .then(({ data }) => { setD(data); applyZoom(data.zoom); window.dispatchEvent(new CustomEvent("sv-layout", { detail: data.layout })); toast.success(msg); })
    .catch((e) => toast.error(errMsg(e)));
  return (
    <>
      <section className="rounded-lg border border-slate-200 p-6 mb-6 max-w-3xl" data-testid="layout-settings">
        <h3 className="font-semibold">Modèle d'affichage</h3>
        <p className="text-sm text-slate-500 mb-4">Disposition de l'application pour tous les techniciens de votre organisation.</p>
        <div className="grid grid-cols-2 gap-3">
          {LAYOUTS.map(([k, label, hint, pic]) => (
            <Choice key={k} on={d?.layout === k} onClick={() => save({ layout: k }, `${label} activé pour toute l'équipe`)} id={`layout-${k}`}>
              <div className="h-16 rounded-md border border-slate-200 overflow-hidden mb-3 bg-slate-50">{pic}</div>
              <p className="font-semibold">{label}</p>
              <p className="text-xs text-slate-500 mt-1">{hint}</p>
            </Choice>
          ))}
        </div>
      </section>
      <section className="rounded-lg border border-slate-200 p-6 mb-6 max-w-3xl" data-testid="display-settings">
        <h3 className="font-semibold">Taille du texte</h3>
        <p className="text-sm text-slate-500 mb-4">S'applique à toute l'application pour tous les techniciens de votre organisation.</p>
        <div className="grid grid-cols-3 gap-3">
          {SIZES.map(([k, label, hint, cls]) => (
            <Choice key={k} on={d?.text_size === k} onClick={() => save({ text_size: k }, "Taille du texte enregistrée pour toute l'équipe")} id={`text-size-${k}`}>
              <p className={`font-semibold ${cls}`}>{label}</p>
              <p className="text-xs text-slate-500 mt-1">{hint}</p>
            </Choice>
          ))}
        </div>
      </section>
    </>
  );
};
